import React from 'react';
import PropTypes from 'prop-types';

class SelectionInput extends React.Component {
  render() {
    const { title,
      inputType,
      userPayrolls,
      optionAttributes,
      onSelectFocus,
      onSelectChange,
      settingsBand,
    } = this.props;

    // #2129: 設定セクションを縦書き帯 + 項目名列構成にする。settingsBand 時は
    // 項目名を th2(単一列)で出す(帯は親が描画)。既定は従来どおり colSpan=2。
    const labelTh = settingsBand
      ? <th className="item th2 no-min-width"><span>{title}</span></th>
      : <th className="th1 item w14 no-min-width" colSpan="2"><span>{title}</span></th>;

    return (
      <tr className="auto-select">
        {labelTh}
        {userPayrolls.map((userPayroll, index) => {
          return (
            <td className="salary w9" key={index}>
              <select className={`inputNumber ${inputType} payment-updater`} name={`user[${userPayroll.uID}][${inputType}]`}
                onChange={(e) => onSelectChange(e, index, inputType)}
                onFocus={(e) => onSelectFocus(e, userPayroll.uID, inputType)}
                value={userPayroll[inputType]}
              >
                {optionAttributes.map((ui, idx) => <option key={idx} value={ui.value}>{ui.text}</option>)}
              </select>
            </td>
          );
        })}
      </tr>
    );
  }
}

SelectionInput.propTypes = {
  title: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onSelectFocus: PropTypes.func.isRequired,
  optionAttributes: PropTypes.array.isRequired,
  settingsBand: PropTypes.bool,
};

export default SelectionInput;
